import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import {
  AdriaticInfoModalStyles,
  CloseButton,
  LeftSide,
  ModalBody,
  ModalContent,
  ModalHeader,
  PreContractPill,
  RightSide,
  TextContainer,
  TitleBox,
} from './AdriaticInfoModal.styles';
import infoIcon from '../../../../assets/redesign_icons/info-icon.svg';
import { downloadResourceDocs } from '../../../../services/axios-client/axeCommons';
import preContractIcon from '../../../../assets/redesign_icons/pre-contract-icon.svg';

function GenialPiuInfoModal({ quotation, setShowModal }) {
  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <AdriaticInfoModalStyles>
      <ModalBody>
        <ModalHeader>
          <LeftSide>
            <TextContainer>
              <TitleBox>
                <img src={infoIcon} alt="Info" />
                <h3>Informazione</h3>
              </TitleBox>
              <p>Qui puoi controllare le informazioni su questa offerta.</p>
            </TextContainer>
          </LeftSide>
          <RightSide>
            {quotation?.product_id === 1 && (
            <PreContractPill onClick={() => downloadResourceDocs(19, 0)} title="Informativa Precontrattuale">
              <img src={preContractIcon} alt="" />
              <p>Informativa Precontrattuale</p>
            </PreContractPill>
            )}
            {quotation?.product_id === 2 && (
            <PreContractPill onClick={() => downloadResourceDocs(28, 0)} title="Informativa Precontrattuale">
              <img src={preContractIcon} alt="" />
              <p>Informativa Precontrattuale</p>
            </PreContractPill>
            )}
            {quotation?.product_id === 3 && (
            <PreContractPill onClick={() => downloadResourceDocs(29, 0)} title="Informativa Precontrattuale">
              <p>Informativa Precontrattuale</p>
            </PreContractPill>
            )}
          </RightSide>
          <CloseButton onClick={closeModal} aria-label="Chiudi">
            <FontAwesomeIcon icon={faTimes} />
          </CloseButton>
        </ModalHeader>

        {quotation?.product_id === 2 ? (
          <ModalContent>
            <div className="card-extra-information">
              <h3>Informazioni Moto</h3>

              <p>
                <b>Cosa è assicurato:</b>
                <br />
                - Dall’utilizzo del veicolo come mezzo di trasporto (in circolazione, in sosta su spazi pubblici, o ricoverato in spazi privati)
                <br />
                - Lesioni personali di qualsiasi soggetto coinvolto, inclusi i trasportati, escluso il conducente se responsabile
                <br />
                - Danni alle cose della persona trasportata se definibili come “terzi”
                <br />
                - Danni causati a terzi dalla persona trasportata
                <br />
                - Danni ambientali causati dal veicolo a seguito di guasto o incidente (in Italia e in Europa secondo Direttiva 2004/35/CE)
                <br />
                - Danni materiali e diretti a terzi provocati da incendio del veicolo (in aree pubbliche, private o aeroportuali) fino al massimale RCA
              </p>
              <br />
              <p>
                <b>Cosa non è assicurato:</b>
                <br />
                - Conducente responsabile del sinistro
                <br />
                - Proprietario, usufruttuario, locatario, acquirente con patto di riservato dominio, loro familiari conviventi o a carico
                <br />
                - Soci a responsabilità illimitata se l’assicurato è una società, loro familiari conviventi o a carico
                <br />
                - Danni avvenuti durante gare, atti di guerra, attentati, atti vandalici, furti, dolo o colpa grave
                <br />
                - Danni causati da eventi naturali, esplosioni naturali, eventi radioattivi (eccetto garanzie specifiche)
              </p>
              <br />
              <p>
                <b>Limitazioni di copertura (rivalsa):</b>
                <br />
                - Guida senza patente, sospesa o scaduta da oltre 6 mesi
                <br />
                - Guida sotto effetti di alcol o sostanze stupefacenti
                <br />
                - Trasporto non a norma dei passeggeri
                <br />
                - Uso del veicolo come scuola guida senza istruttore
                <br />
                - Partecipazione a gare o competizioni
                <br />
                - Dolo del conducente
              </p>
              <br />
              <p>
                <b>Coperture opzionali per moto:</b>
                <br />
                - Bonus Protetto
                <br />
                - Protezione Rivalse
                <br />
                - Furto e Incendio
                <br />
                - Eventi Naturali
                <br />
                - Collisione con veicolo identificato o non identificato
                <br />
                - Collisione con animali
                <br />
                - Danni all’abbigliamento
                <br />
                - Atti vandalici
                <br />
                - Assistenza stradale, Infortuni del Conducente, Tutela Legale
              </p>
            </div>
          </ModalContent>
        ) : quotation?.product_id === 1 ? (
          <ModalContent>
            <div className="card-extra-information">
              <h3>Informazioni Auto</h3>

              <p>
                <b>Cosa è assicurato:</b>
                <br />
                - Dall’utilizzo del veicolo come mezzo di trasporto (in circolazione, in sosta su spazi pubblici o ricoverato in spazi privati)
                <br />
                - Dal gancio traino e dall’eventuale rimorchio agganciato al veicolo, se il traino è effettuato secondo la legge
                <br />
                - Lesioni personali di qualsiasi soggetto coinvolto in un sinistro, anche trasportati, escluso il conducente responsabile
                <br />
                - Danni alle cose delle persone trasportate purché definibili come “terzi”
                <br />
                - Danni causati a terzi dalle persone trasportate
                <br />
                - Danni ambientali causati dal veicolo a seguito di guasto o incidente secondo la legge sui danni ambientali (solo Italia ed Europa)
                <br />
                - Danni materiali e diretti provocati a terzi dall’incendio del veicolo per cause conseguenti alla circolazione, fermate e soste in aree pubbliche
                <br />
                - Danni materiali e diretti provocati a terzi dall’incendio del veicolo in aree private o aeroportuali con massimale minimo di legge RCA
              </p>
              <br />
              <p>
                <b>Garanzie opzionali in aggiunta all’RCA:</b>
                <br />
                - Bonus protetto
                <br />
                - Protezione rivalse
              </p>
              <br />
              <p>
                <b>Garanzie opzionali relative al veicolo:</b>
                <br />
                - Cristalli
                <br />
                - Furto e Incendio
                <br />
                - Estensioni Furto e Incendio
                <br />
                - Eventi naturali
                <br />
                - Collisione con veicolo identificato
                <br />
                - Collisione con veicolo non identificato
                <br />
                - Collisione con animali
                <br />
                - Estensione Kasko completa (urto, uscita di strada, ribaltamento)
                <br />
                - Atti vandalici
              </p>

              <p>
                <b>Ulteriori garanzie opzionali:</b>
                <br />
                - Assistenza stradale (Base, Vip)
                <br />
                - Infortuni del Conducente
                <br />
                - Tutela Legale
                <br />
                - Protezione patente
              </p>
              <br />
              <p>
                <b>Cosa non è assicurato:</b>
                <br />
                - Conducente responsabile
                <br />
                - Proprietario, usufruttuario, acquirente con patto di riservato dominio, locatario, loro familiari conviventi o a carico
                <br />
                - Soci a responsabilità illimitata se l’assicurato è una società, loro familiari conviventi o a carico
                <br />
                - Danni durante gare, atti di guerra, attentati, atti vandalici, furti, dolo o colpa grave
                <br />
                - Danni causati da terremoti, eruzioni vulcaniche, tsunami, esplosioni naturali o eventi radioattivi (eccetto garanzie specifiche)
              </p>
              <br />
              <p>
                <b>Limiti di copertura / Rivalsa:</b>
                <br />
                - Guida senza patente, sospesa, revocata o scaduta da oltre sei mesi
                <br />
                - Guida sotto effetto di alcol o sostanze stupefacenti
                <br />
                - Trasporto non conforme delle persone o delle loro cose
                <br />
                - Uso del veicolo per esercitazione alla guida senza istruttore abilitato
                <br />
                - Conducente non abilitato secondo le norme vigenti
                <br />
                - Fino a 5.000 € se guida non conforme ai termini di esperienza previsti
              </p>
              <br />
              <p>
                <b>Dove vale la copertura:</b>
                <br />
                Italia, Vaticano, San Marino, Spazio Economico Europeo, Regno Unito, Principato di Monaco, Svizzera, Andorra, Serbia, Montenegro, Bosnia ed Erzegovina. Esclusi gli stati barrati sulla Carta Verde.
              </p>
              <br />
              <p>
                <b>Obblighi dell’assicurato:</b>
                <br />
                Le dichiarazioni devono essere esatte. Variazioni nei dati devono essere comunicate immediatamente. Eventuali inesattezze o omissioni possono comportare rivalsa o perdita del diritto all’indennizzo.
              </p>
              <br />
              <p>
                <b>Pagamento:</b>
                <br />
                Premio annuale, frazionabile in semestrale con maggiorazione 4%. Modalità: carta di credito, bonifico, tabaccherie PUNTOLIS, edicole o bar convenzionati LIS Pay S.p.A.
              </p>
              <br />
              <p>
                <b>Decorrenza e sospensione:</b>
                <br />
                Copertura di 1 anno dalla decorrenza in polizza. Attiva fino al 15° giorno successivo alla scadenza se non rinnovata. Possibile sospensione fino a 10 mesi cumulativi (11 mesi per veicolo storico).
              </p>
              <br />
              <p>
                <b>Disdetta / Ripensamento:</b>
                <br />
                Contratto senza tacito rinnovo. Diritto di ripensamento entro 14 giorni dall’emissione con rimborso del premio al netto delle imposte.
              </p>
            </div>
          </ModalContent>
        ) : quotation?.product_id === 3 ? (
          <ModalContent>
            <div className="card-extra-information">
              <h3>Informazioni Autocarro</h3>

              <p>
                <b>Che cosa è assicurato:</b>
                <br />
                - Dall’utilizzo del veicolo come mezzo di trasporto (in circolazione, in sosta su spazi pubblici o ricoverato in spazi privati)
                <br />
                - Lesioni personali di qualsiasi soggetto coinvolto in un sinistro, anche trasportati, escluso il conducente responsabile
                <br />
                - Danni alle cose della persona trasportata purché definibili come “terzi”
                <br />
                - Danni causati a terzi dalle persone trasportate
                <br />
                - Danni alle parti interne del veicolo causati dal trasporto documentato di vittime di incidenti stradali fino al posto di soccorso medico (max 300 € per evento)
                <br />
                - Danni causati a terzi dal veicolo guidato a insaputa del proprietario da figli minori o persone sotto la sua tutela
                <br />
                - Danni involontariamente causati a terzi nel corso di operazioni di carico e scarico da terra sul veicolo e viceversa, purché senza dispositivi meccanici
                <br />
                - Danni ambientali causati dal veicolo a seguito di guasto o incidente secondo la legge sui danni ambientali (solo Italia ed Europa)
                <br />
                - Danni materiali e diretti provocati a terzi dall’incendio del veicolo in aree private o aeroportuali con massimale minimo di legge RCA (6.500.000 € per danni a cose e 6.500.000 € per danni alle persone)
              </p>
              <br />
              <p>
                <b>Che cosa non è assicurato:</b>
                <br />
                - Conducente responsabile, per danni a persona e cose
                <br />
                - Proprietario, usufruttuario, acquirente con patto di riservato dominio, locatario, loro familiari conviventi o a carico
                <br />
                - Soci a responsabilità illimitata se l’assicurato è una società, loro familiari conviventi o a carico
                <br />
                - Danni durante gare o competizioni automobilistiche e prove ufficiali
                <br />
                - Conseguenze di atti di guerra, attentati, atti di terrorismo (eccetto RCA), scioperi, sommosse, risse, sabotaggio
                <br />
                - Furto e rapina (eccetto garanzie Furto e Incendio)
                <br />
                - Danni intenzionali (dolo) o da colpa grave, salvo garanzie specifiche
                <br />
                - Terremoti, eruzioni vulcaniche, tsunami, eventi naturali (eccetto garanzie specifiche)
              </p>
              <br />
              <p>
                <b>Coperture opzionali in aggiunta all’RCA:</b>
                <br />
                - Rischio traino rimorchi con targa propria
                <br />
                - Protezione rivalse
              </p>
              <br />
              <p>
                <b>Garanzie opzionali relative al veicolo:</b>
                <br />
                - Cristalli
                <br />
                - Furto e Incendio
                <br />
                - Estensioni Furto e Incendio
                <br />
                - Collisione con veicolo non identificato
                <br />
                - Collisione con animali
              </p>
              <br />
              <p>
                <b>Ulteriori garanzie opzionali:</b>
                <br />
                - Assistenza stradale
                <br />
                - Infortuni del Conducente
                <br />
                - Tutela Legale
                <br />
                - Protezione patente
                <br />
                - Responsabilità Civile del Camperista
              </p>
              <br />
              <p>
                <b>Limiti di copertura / Rivalsa:</b>
                <br />
                - Guida senza patente, sospesa, revocata o scaduta da oltre sei mesi
                <br />
                - Guida sotto effetto di sostanze stupefacenti o alcol oltre i limiti di legge
                <br />
                - Trasporto non conforme delle persone o delle loro cose
                <br />
                - Uso del veicolo per esercitazione alla guida senza istruttore abilitato
                <br />
                - Fino a 5.000 € se la guida non rispetta i termini di esperienza previsti
              </p>
              <br />
              <p>
                <b>Dove vale la copertura:</b>
                <br />
                Italia, Vaticano, San Marino, Spazio Economico Europeo, Regno Unito, Principato di Monaco, Svizzera, Andorra, Serbia, Montenegro, Bosnia ed Erzegovina. Esclusi gli stati barrati sulla Carta Verde.
              </p>
              <br />
              <p>
                <b>Obblighi dell’assicurato:</b>
                <br />
                Le dichiarazioni devono essere esatte. Variazioni nei dati devono essere comunicate immediatamente. Eventuali inesattezze o omissioni possono comportare rivalsa o perdita del diritto all’indennizzo.
              </p>
              <br />
              <p>
                <b>Pagamento:</b>
                <br />
                Premio annuale, frazionabile in semestrale con maggiorazione 4%. Modalità: carta di credito, bonifico, tabaccherie PUNTOLIS, edicole o bar convenzionati LIS Pay S.p.A.
              </p>
              <br />
              <p>
                <b>Decorrenza e sospensione:</b>
                <br />
                Copertura di 1 anno dalla decorrenza in polizza. Attiva fino al 15° giorno successivo alla scadenza se non rinnovata. Possibile sospensione fino a 10 mesi cumulativi (11 mesi per veicolo storico).
              </p>
              <br />
              <p>
                <b>Disdetta / Ripensamento:</b>
                <br />
                Contratto senza tacito rinnovo. Diritto di ripensamento entro 14 giorni dall’emissione con rimborso del premio al netto delle imposte.
              </p>
            </div>
          </ModalContent>
        ) : null}
      </ModalBody>
    </AdriaticInfoModalStyles>
  );
}

export default GenialPiuInfoModal;
